// extracted by mini-css-extract-plugin
export default {"americanSansBold":"\"AmericanSans-Bold\"","americanSansRegular":"\"AmericanSans-Regular\""};